import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const CTA_KEY = "ctas";

export const giveKeys = createKeys(featureKeys.GIVE_FEATURE_KEY, {
  ctas: (fundID) => [CTA_KEY, fundID],
});
